import React, { useEffect } from 'react'
import Scroll from 'react-scroll'
import config from '../config.json'
import Translation from './Translation'

const scroller = Scroll.scroller

const CompesoIFrame = ({src, title='', closeFunction=false, cinemaPath, id, cinemaUserTextHint, scrollToPosition, translation}) => {

    const isMobile = () => {
        const width = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/"/g, '')

        return width < config.breakpoints.slidebarRight
    }

    const scrollIframeIntoView = (isMobile, iframe) => {
        if(isMobile) {
            iframe.scrollIntoView({
                behavior: 'smooth'
            })
        } else {
            scroller.scrollTo(scrollToPosition + ' performance-iframe', {
                smooth: true,
                offset: -200,
                isDynamic: true
            })
        }
    }


    useEffect(() => {
        const iframe = document.getElementById(id)
        const header = document.getElementById('site-header')


        const resize = () => {
            if(window.Compeso && window.Compeso.updateOrInitializeIFrameResizer) {
                window.Compeso.updateOrInitializeIFrameResizer();
            }
        }

        _.delay(resize, 1000)
        

        const onScrollPositionAdvice = args => {
            const mobile = isMobile()
            const iFrameBounding = iframe.getBoundingClientRect()
            const headerBounding = header.getBoundingClientRect()

            if(mobile || iFrameBounding.top < headerBounding.height + 20) {
                scrollIframeIntoView(mobile, iframe)
            }
        }


        if(window.Compeso && window.Compeso.setScrollPositionAdviceCallback) {
            window.Compeso.setScrollPositionAdviceCallback(onScrollPositionAdvice)
        }


        return () => {
            if(iframe && iframe.iFrameResizer) {
                iframe.iFrameResizer.removeListeners();
            }
        }
    })

    const hasTitleClass = title !== '' ? ' has-title' : ''

    return (
        <div id="compeso-iframe" className='theme-radius-posters-full'>
            <div className={'header-wrapper' + hasTitleClass}>
                {title !== '' && <h2 className='title-large'>{title}</h2>}
                {cinemaUserTextHint && <h2 className='title-large'><Translation id="user_text_hint" trans={translation}>Login</Translation></h2>}
            </div>
            <iframe
                style={{width:'100%', height:'100%'}}
                className='iframe-webshop'
                src={src}
                id={id}
                scrolling="no"  
                allow={'clipboard-read; clipboard-write; payment; camera;'}
            />     
        </div>
    )  
}

export default CompesoIFrame